<template lang="pug">
.reaction-contents
    //- include ../../base.pug
    .actions
        el-button(
            v-if="reaction.deleted"
            circle
            size="mini"
            type="info"
            icon="el-icon-fa-trash-restore fas"
            @click="restoreReaction"
        )
        el-button(
            v-else
            circle
            size="mini"
            type="danger"
            icon="el-icon-fa-trash-alt far"
            @click="removeReaction"
        )

    input-content.reaction-content(
        v-if="edit"
        v-for="content in reaction.contents"
        :key="content.id"
        :section="section"
        :information="information"
        :reaction="reaction"
        :content="content"
        :config="getConfig(content.key)"
        :options="options"
        :section-setting-values="sectionSettingValues"
        :edit="edit"
    )
</template>

<script>

import _ from 'lodash'

import store from '@/store'
import InputContent from './Partials/ReactionInputContent'

export default {
    name: 'Reaction',
    components: {
        InputContent
    },
    props: {
        section: {
            type: Object,
            required: true
        },
        reaction: {
            type: Object,
            required: true
        },
        information: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        edit: {
            type: Boolean,
            required: true
        },

        sectionSettingValues: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    computed: {
        // inputType() {
        //     if (typeof(this.reaction.input_type) !== undefined) {
        //         switch(this.reaction.input_type){
        //             case 'input':
        //             case 'text':
        //                 return 'Eingabe'
        //             case 'multiple-choice':
        //             case 'multiple_choice':
        //             case 'select':
        //                 return 'Mehrfachauswahl'
        //             case 'single_choice':
        //             case 'radio':
        //                 return 'Auswahl'
        //             case 'next':
        //             case 'nextInformation':
        //             case 'nextinformation':
        //                 return 'Nächste'
        //             default:
        //                 return 'Antwort'
        //         }
        //     }
        //     return 'Antwort'
        // },
    },
    methods: {
        getConfig(key) {
            const contents = this.config.contents || []
            return contents.find(config => config.key === key)
        },
        removeReaction() {
            const information = this.information
            // store.commit(`${this.module}/form/markReactionAsDeleted`, { i: this.i, s: this.s, inf: this.inf, reac: this.reac })

            const i = information.reactions.findIndex(el => el.id === this.reaction.id)
            this.$delete(this.information.reactions, i);
        },
        restoreReaction() {
            // store.commit(`${this.module}/form/unmarkReactionAsDeleted`, { i: this.i, s: this.s, inf: this.inf, reac: this.reac })
        },
    }
}
</script>

<style lang="sass" scoped>
.reaction-contents
    display: flex
    justify-content: flex-end
    gap: 0.5rem
    .reaction-content
        width: 100%
.actions
    padding-top: 27px
</style>
